import { Text } from '@akin-home/text/native';
import { colors, spacing, typography } from '@akin-home/theme';
import { TinyColor } from '@ctrl/tinycolor';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import React, { forwardRef, useState } from 'react';
import { TextInput as ReactTextInput, View } from 'react-native';
import { Hoverable } from 'react-native-web-hover';
import styled from 'styled-components/native';
import { TextInputPresets } from './TextInput.presets';
import { TextInputProps } from './TextInput.props';

/**
 * For your text input displaying needs.
 *
 * This component is a HOC over the built-in React Native one.
 */
// eslint-disable-next-line react/display-name
export const TextInput = forwardRef<ReactTextInput, TextInputProps>(
  (props, ref: any) => {
    const {
      preset = 'default',
      error,
      style,
      right,
      outerContainerStyle,
      innerContainerStyle,
      textInputStyle,
      ...rest
    } = props;

    const [borderColor, setBorderColor] = useState<string>(
      preset === 'default' ? colors.outline.blue : colors.secondary[700]
    );

    const onBlur = (e: any) => {
      setBorderColor(colors.outline.blue);
      rest.onBlur?.(e);
    };

    const onFocus = (e: any) => {
      setBorderColor(colors.secondary[700]);
      rest.onFocus?.(e);
    };

    return (
      <>
        <Hoverable style={[style, outerContainerStyle]}>
          {({ hovered }) => (
            <InputContainer
              hovered={hovered}
              borderColor={borderColor}
              preset={preset}
              style={[style, innerContainerStyle]}
            >
              {props.icon ? <FontAwesomeIcon icon={props.icon} /> : null}
              <Input
                {...rest}
                style={textInputStyle}
                ref={ref}
                onBlur={onBlur}
                onFocus={onFocus}
              />

              {right || null}
            </InputContainer>
          )}
        </Hoverable>
        {error && <Text preset="error">{error.message}</Text>}
      </>
    );
  }
);

const InputContainer = styled(View)<{
  hovered?: boolean;
  borderColor: string;
  preset: TextInputPresets;
}>`
  flex-direction: row;
  gap: 10px;
  align-items: center;
  border-color: ${colors.outline.blue};
  min-width: 210px;
  border-width: 2px;
  border-radius: 10px;
  padding: 0 ${spacing[4]}px;
  ${({ hovered, borderColor, preset }) => `
    border-color: ${
      hovered
        ? new TinyColor(borderColor).darken(20).toHexString()
        : borderColor
    };
    ${presets[preset] || ''}
  `}
`;

const Input = styled(ReactTextInput)`
  font-family: ${typography.primary.regular};
  color: ${colors.grey.dark};
  font-size: 18px;
  height: 56px;
  min-height: 56px;
  flex: 1;
`;
const presets = {
  default: '',
  secondary: `border-color: ${colors.secondary[700]}; background-color: ${colors.secondary[700]};`,
  focus: `border-color: ${colors.secondary[700]};`,
  white: `background-color: white;`,
};
